module.exports = __webpack_public_path__ + "img/reset-password.82c6cc2d.png";